import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import AuthGuard from 'src/auth/AuthGuard';
// layouts
import CompactLayout from 'src/layouts/compact';
import DashboardLayout from 'src/layouts/dashboard/DashboardLayout';
import {
  Business,
  Employee,
  Event,
  Group,
  History,
  MainVisual,
  Materials,
  Menu,
  News,
  Notice,
  Partner,
  Popup,
  Recruit,
  Settings,
} from 'src/screens';

// auth
import GuestGuard from '../auth/GuestGuard';

// screens
import { Category, Guide, Login, Page403, Page404, ResetPassword } from './elements';
import { PATH_AUTH, PATH_PAGE } from './paths';

// ----------------------------------------------------------------------

const routes: RouteObject[] = [
  {
    path: PATH_AUTH.root,
    element: <Navigate to={PATH_PAGE.management.pr.news} />,
  },
  {
    path: PATH_AUTH.login,
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    ),
  },
  {
    element: <CompactLayout />,
    children: [
      {
        path: PATH_AUTH.resetPassword,
        element: <ResetPassword />,
      },
      {
        path: PATH_PAGE.page404,
        element: <Page404 />,
      },
      {
        path: PATH_PAGE.page403,
        element: <Page403 />,
      },
    ],
  },
  {
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: PATH_PAGE.adminManagement.menu,
        element: <Menu />,
      },
      {
        path: PATH_PAGE.adminManagement.group,
        element: <Group />,
      },
      {
        path: PATH_PAGE.adminManagement.employee,
        element: <Employee />,
      },
      {
        path: PATH_PAGE.management.recruit,
        element: <Recruit />,
      },
      {
        path: PATH_PAGE.management.contents.popup,
        element: <Popup />,
      },
      {
        path: PATH_PAGE.management.contents.mainVisual,
        element: <MainVisual />,
      },
      {
        path: PATH_PAGE.management.contents.business,
        element: <Business />,
      },
      {
        path: PATH_PAGE.management.contents.category,
        element: <Category />,
      },
      {
        path: PATH_PAGE.management.company.history,
        element: <History />,
      },
      {
        path: PATH_PAGE.management.company.partner,
        element: <Partner />,
      },
      {
        path: PATH_PAGE.management.company.settings,
        element: <Settings />,
      },
      {
        path: PATH_PAGE.management.ir.event,
        element: <Event />,
      },
      {
        path: PATH_PAGE.management.ir.materials,
        element: <Materials />,
      },
      {
        path: PATH_PAGE.management.pr.news,
        element: <News />,
      },
      {
        path: PATH_PAGE.management.pr.notice,
        element: <Notice />,
      },
      {
        path: PATH_PAGE.guide.root,
        element: <Guide />,
      },
    ],
  },
  { path: '*', element: <Navigate to={PATH_PAGE.page404} replace /> },
];
const router = createBrowserRouter(routes, {
  basename: '/',
  future: {
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_partialHydration: true,
  },
});
export default router;
